<!--
 * @FileDescription: 使用中
 * @Author: 陈文景
 * @Date: 2023-02-24 15:39:48
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="using-box">
    <el-popover placement="bottom-start" width="368" trigger="click">
      <div>
        <p class="popover-tips">最多可设置16个热搜词</p>

        <el-input v-model="keyword" :maxlength="30" show-word-limit size="medium" placeholder="请输入热搜词" />

        <div class="footer-botton">
          <el-button :disabled="!keyword" size="mini" @click="clear">清空</el-button>
          <el-button :disabled="!keyword" type="primary" size="mini" @click="define">确定</el-button>
        </div>
      </div>
      <el-button slot="reference" type="primary" size="medium">添加热搜词</el-button>
    </el-popover>

    <p class="tips">注：前台最多显示16个热搜词！</p>

    <el-table v-loading="loading" :data="usings" row-key="id" size="medium" border stripe :style="{ width: '100%' }" height="100%">
      <el-table-column label="排序" align="center" width="80">
        <template>
          <span class="move-icon">
            <i class="iconfont icon-line-height" />
          </span>
        </template>
      </el-table-column>
      <el-table-column type="index" align="center" label="序号" width="80" />
      <el-table-column prop="term" align="center" label="热搜词" />
      <el-table-column align="center" label="状态">
        <template v-slot="{ row }">
          {{ row.status === 0 ? '弃用' : '启用' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="生效时间">
        <template v-slot="{ row }">
          {{ formatTimeStamp(row.createDate) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template v-slot="{ row }">
          <el-button type="text" size="medium" @click="() => onDeprecate(row)">弃用</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import API from '@/api'
import { Sortable } from 'sortablejs'
import { formatTimeStamp } from '@/utils/moment.js'

let parameter = {
  type: 1, // 1.启用 2.弃用
  terms: [], // 批量搜索词
  pageSize: 20,
  pageNumber: 1
}

export default {
  data() {
    return {
      formatTimeStamp,

      keyword: undefined, // 添加热搜词

      parameter: { ...parameter }, // 获取已启用列表的请求参数

      usings: [], // 热搜词列表
      loading: false // 表格Loading
    }
  },
  mounted() {
    this.drag()
  },
  methods: {
    /**
     * API 获取已启用热搜词列表
     */
    async getHotsearchList() {
      try {
        this.loading = true
        let { data } = await API.getHotsearchList(this.parameter)
        this.total = data.total
        this.usings = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * API 新增热搜词
     *
     * @param {String} term 新增的热搜词
     */
    async addHotsearchWords(term) {
      let { code, message } = await API.addHotsearchWords({ term })
      if (code === 10000) {
        this.clear()
        this.getHotsearchList()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * API 修改热搜词状态
     *
     * @param {Object} parameter 请求参数: {id: '', status: ''}
     */
    async editHotsearchWordsStatus(parameter) {
      let { code, message } = await API.editHotsearchWordsStatus(parameter)
      if (code === 10000) {
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
      this.getHotsearchList()
    },

    /**
     * API 设置拖拽排序结果
     *
     * @param {Object} parameter 请求参数: {id: '', position: '', targetId: '', targetPosition: ''}
     */
    async setDragSort(parameter) {
      let { code, message } = await API.setDragSort(parameter)
      if (code === 10000) {
        this.getHotsearchList()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 初始化拖拽功能
     * 插件中文文档: https://www.itxst.com/sortablejs/neuinffi.html
     * 插件官方文档: https://github.com/SortableJS/Sortable/tree/master/plugins/MultiDrag
     */
    drag() {
      let tbody = document.querySelector('.el-table__body-wrapper tbody')
      if (tbody) {
        this.sortable = new Sortable(tbody, {
          handle: '.move-icon', // 句柄（鼠标需按住有该类的元素才可以拖拽）
          animation: 500, // 拖拽的动画执行时间
          onEnd: ({ newIndex, oldIndex }) => {
            if (newIndex !== oldIndex) {
              let original = this.usings[oldIndex]
              let next = this.usings[newIndex]
              let parameter = {
                id: original.id, // 当前被拖拽元素的ID
                position: original.orderNum, // 当前被拖拽元素的orderNum
                targetId: next.id, // 目标位置元素的ID
                targetPosition: next.orderNum, // 目标位置元素的orderNum
                type: 3
              }
              this.setDragSort(parameter)
            }
          }
        })
      }
    },

    /**
     * 清空添加输入框
     */
    clear() {
      this.keyword = undefined
    },

    /**
     * 确认添加按钮
     */
    define() {
      this.addHotsearchWords(this.keyword.trim())
    },

    /**
     * 弃用按钮的回调事件
     *
     * @param {Object} row 当前点击的行数据
     */
    onDeprecate(row) {
      this.$confirm('此操作将弃用该热搜词, 是否继续?', '提示', {
        confirmButtonText: '弃用',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.editHotsearchWordsStatus({ id: row.id, status: 0 })
        })
        .catch(() => {
          this.$message.info('已取消操作')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.using-box {
  height: calc(100% - 100px);
}
.el-input {
  margin: 10px 0;
}

.popover-tips {
  color: #99c41c;
  font-size: 12px;
}

.footer-botton {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.tips {
  color: #d14a4a;
  font-size: 12px;
  margin: 15px 0;
}

.move-icon {
  font-size: 18px;
  padding: 5px;
  cursor: move;
  user-select: none;
  &:hover {
    color: #99c41c;
  }
}
</style>
